// Nota: qui ora tengo solo il componente React.
// La funzione helper l’ho spostata in /utils/getPolicyIdForLang.ts per rispettare le regole di Fast Refresh.

// LIBRERIE/IMPORTS
import React from 'react';
import { useParams } from 'react-router-dom';

// CONFIGURAZIONI
import { AGENCY_ID } from '../../config/appConfig';

// COMPONENTI
import Privacy from './Routes/Privacy';
import Cookies from './Routes/Cookies';

// UTILS
import { getPolicyIdForLang } from '../../utils/getPolicyIdForLang';

interface PolicyPageRouteProps {
    policyType: 'privacy' | 'cookies';
}

/**
 * Questo componente gestisce le route dinamiche:
 * - /:lng/privacy
 * - /:lng/cookies
 *
 * Qui prendo la lingua dall’URL, calcolo il policyId corretto,
 * e monto Privacy o Cookies in base al prop policyType.
 */
const PolicyPageRoute: React.FC<PolicyPageRouteProps> = ({ policyType }) => {
    // recupero la lingua dall’URL
    const { lng } = useParams<{ lng: string }>();

    // calcolo l’id della policy corretto tramite l’helper
    const policyId = getPolicyIdForLang(lng);

    // monto il componente giusto
    if (policyType === 'privacy') {
        return <Privacy agencyId={AGENCY_ID} policy={policyId} isPrivacy={true} />;
    } else if (policyType === 'cookies') {
        return <Cookies agencyId={AGENCY_ID} policy={policyId} isPrivacy={false} />;
    } else {
        // caso improbabile, ma meglio loggare
        console.error("Invalid 'policyType' passato a PolicyPageRoute:", policyType);
        return null;
    }
};

export default PolicyPageRoute;